export default __webpack_public_path__ + "static/media/Sui-Foundation.6b42f8cf.png";